export const sortByKey = (array, key, order = "asc") => {
  if (!Array.isArray(array) || array.length === 0) {
    console.warn("Invalid input: Expected a non-empty array.");
    return [];
  }

  return [...array].sort((a, b) => {
    if (!(key in a) || !(key in b)) {
      console.warn(`Key "${key}" not found in one or more objects.`);
      return 0;
    }

    const valueA = a[key];
    const valueB = b[key];

    // 🔹 Handle numbers, strings, and dates
    if (typeof valueA === "number" && typeof valueB === "number") {
      return order === "asc" ? valueA - valueB : valueB - valueA;
    } else if (typeof valueA === "string" && typeof valueB === "string") {
      return order === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    } else if (valueA instanceof Date && valueB instanceof Date) {
      return order === "asc" ? valueA - valueB : valueB - valueA;
    } else {
      console.warn(`Unsupported data type for sorting key "${key}".`);
      return 0;
    }
  });
};
